import dayjs from "dayjs";
import { withAdminAuth } from "../../../components/GetAuth";
import PageHeader from "../../../components/PageHeader";
import { CurrencyFormatter } from "../../../components/Helpers";
import { useWebsite } from "../../../../context/WebsiteContext";
import { useSiteBranding } from "../../../../hooks/useSiteBranding";
import styles from "../reports.module.css";
import useServerReport from "../components/useServerReport";
import ReportToolbar from "../components/ReportToolbar";
import ReportTable from "../components/ReportTable";
import ServiceFilter from "../components/ServiceFilter";
import { toFixed2, toNumber } from "../components/exportUtils";

const formatDate = (value) => (value ? dayjs(value).format("DD/MM/YYYY") : "-");

const columns = [
    { key: "booking_id_str", label: "Booking Id", primary: true },
    { key: "created_by", label: "Booking Created By" },
    { key: "amount", label: "Paid Amount", align: "right", render: (row) => CurrencyFormatter(toNumber(row?.amount)), exportValue: (row) => toFixed2(row?.amount) },
    { key: "note", label: "Payment Notes" },
    { key: "payment_added_by", label: "Payment Added By" },
    { key: "created_at", label: "Payment Date", render: (row) => formatDate(row?.created_at), exportValue: (row) => formatDate(row?.created_at) },
];

const PaymentReports = () => {
    const { websiteData } = useWebsite();
    useSiteBranding("Payment Reports", websiteData);

    const report = useServerReport("report/payment-histroies", { service: "all" });

    return (<div className={`${styles.MainDiv}`}>
        <PageHeader title="Payment Reports" trail={[{ label: "Reports" }]} />

        <div className={`${styles.MainCard}`}>
            <ReportToolbar report={report} columns={columns} title="Payment Report" filename="payment-report" searchPlaceholder="Search by booking, user or note">
                <ServiceFilter report={report} />
            </ReportToolbar>
            <ReportTable report={report} columns={columns} minWidth={800} />
        </div>
    </div>);
};

export default withAdminAuth(PaymentReports);
